const exchangeRates = {
  INR: {
    USD: 0.0104,
    EUR: 0.00895,
    INR: 1,
    SHARE: 1,
  },

  USD: {
    INR: 95.96,
    EUR: 0.93,
    USD: 1,
    SHARE: 1,
  },

  EUR: {
    INR: 111.4,
    USD: 1.08,
    EUR: 1,
    SHARE: 1,
  },

  SHARE: {
    INR: 1,
    USD: 1,
    EUR: 1,
    SHARE: 1,
  },
};

const currencySymbols = {
  INR: "₹",
  USD: "$",
  EUR: "€",
};

export function convertCurrency(amount, fromCurrency, toCurrency, noIcon) {
  if (
    !exchangeRates[fromCurrency] ||
    !exchangeRates[fromCurrency][toCurrency]
  ) {
    throw new Error("Unsupported currency conversion");
  }

  if (fromCurrency === "SHARE" || toCurrency === "SHARE") {
    if (noIcon) {
      return `${amount}`;
    } else {
      return `${amount}%`;
    }
  }

  if (isNaN(amount)) {
    return `${currencySymbols[toCurrency]}0.00`;
  }

  if (fromCurrency === toCurrency) {
    return `${noIcon ? "" : currencySymbols[toCurrency]}${amount}`;
  }

  const rate = exchangeRates[fromCurrency][toCurrency];
  const converted = (amount * rate).toFixed(2);

  if (noIcon) {
    return `${converted}`;
  } else {
    return `${currencySymbols[toCurrency]}${converted}`;
  }
}
